const LOGIN_MODAL_VIEWS = {
  OTP: 'OTP',
  LOGIN: 'LOGIN'
}

export default LOGIN_MODAL_VIEWS;
